var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.$t("insureText.tbsm.title")))]),_c('p',{staticClass:"pre_",domProps:{"innerHTML":_vm._s(_vm.$t('insureText.tbsm.' + _vm.p))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }